import _axios from '@/assets/utils/_axios'
import { _confirm, _alert, _loading } from '../../assets/utils/utils'
import Router from '@/router'

//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;

export default {
  async staffLists({ commit, getters,dispatch }, {data,type,successFun}){
    let url = '',PAGE = Router.currentRoute.query.page || 1;
    switch (type) {
      case '0':url = '/pc/Travel/GuideList'; break;
      case '1':url = '/pc/Travel/LeaderList'; break;
      case '2':url = '/pc/Travel/GuideList'; break;
      case '3':url = '/pc/Travel/GuideList'; break;
      case '4':url = '/pc/Travel/GuideList'; break;
    }
    let res = await _axios.post(url, {
      num:NUM,
      page:PAGE,
      ...data
    });
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info ||res.data.list ||res.data || [],
          total = res.total_nums || res.num || res.counts || res.count || res.data.count || 0;
      let name = Router.currentRoute.name,
          query = Router.currentRoute.query;
      if (!lists[0] && total > 0) {
        Router.replace({name,query:{...query,page:PAGE - 1}});
      }
      //else {  Router.replace({name,query:{...query,page:1}}); }
      commit('UPDATEADMINDATALIST', { total, lists });
      if (successFun) successFun(res);
      return res;
    }
  },
  /*管理员获取提现列表、用户列表、发票列表、数据统计、广告位、收入明细列表*/
  async getAdminDataLists ({ commit, getters,dispatch }, {data,type,successFun}) {
    let url = '',PAGE = Router.currentRoute.query.page || 1;
    let storeType = data.type*1;
    switch (type) {
      case 'PaymentList':url = '/pc/Admin/PaymentPendingList'; break;
      case 'PaymentRecordList':url = '/pc/Admin/PaymentRecordList'; break;
      case 'withdrawalTravelList':url = '/pc/Admin/SubmitPendingTravelList'; break;
      case 'withdrawalHotelList':url = '/pc/Admin/SubmitPendingHotelList'; break;
      case 'withdrawVocation':url = '/pc/Admin/getProductWithdrawList'; break;
      case 'userList':url = '/pc/Admin/UserList'; break;
      case 'invoice':url = '/pc/Admin/getDrawABillList'; break;
      case 'RefundList':url = '/pc/Admin/RefundRecordList'; break;
      case 'ticketList':url = '/pc/Admin/getTicketList'; break;
      case 'chart':url = '/pc/Admin/statisticalReport2'; break;
      case 'advertise':url = '/pc/Admin/PromoteList'; break;
      case 'income':url = '/pc/Admin/TradeRecordList'; break;
      case 'group':
         url = '/pc/Admin/GroupList';
          delete data.tab; 
        break;
      case 'hotelActi':url = '/pc/Admin/adminShowHotelActive'; break;
      case 'homestayActi':url = '/pc/Admin/getHomestayOnsaleList'; break;
      case 'ticket':url = '/pc/Admin/getUserDetails'; break;
      case 'ticketList':url = '/pc/Admin/getTicketList'; break;
      
      case 'productList':
        if (getters.isAdmin) url = '/pc/Admin/getProductList';
        else { 
          if (Router.currentRoute.path.includes('route')) url = 'pc/Brandhall/getItineraryDetails'
          else url = 'pc/Brandhall/getOnsale'
        }
        break;
      case 'storeList':
        switch (storeType) {
          case 2:
            if (getters.isAdmin) url = data.confirm?'/pc/Admin/EditTravelList':'/pc/Admin/RegTravelList'
            else url = '/pc/Travel/GuideList';
            delete data.confirm;
            delete data.storeType;
            delete data.store_type;
            break;
          case 3:
            url =data.confirm?'/pc/Admin/EditHotelList':'/pc/Admin/RegHotelList'; 
            delete data.confirm;
            delete data.storeType;
            break;
          case 4:
            if (getters.isAdmin) url = '/pc/Admin/getGuideInfoList';
            else url = '/pc/Travel/GuideList'
            break;
          case 5:url = '/pc/Admin/getHomestayInfo'; break;
          case 6:url = '/pc/Admin/getViewpointList'; break;
          case 8:url = '/pc/Admin/getBrandhallList'; break;
        }
        break;
      case 'storeListSearch':
        url = '/pc/Admin/StoreList';
        break;
      case 'payList':
        if (storeType == 4) url = 'pc/Common/getStorePayList'
        else url = storeType === 2 ? '/pc/Admin/getTravelPayList' : '/pc/Admin/getStoreIncomeList';
        break;
      case 'creditList':
        url = storeType === 2 ? '/pc/Admin/getTravelIntegralList' : '/pc/Admin/getStoreActiveList';
        break;
      case 'payDetail':
        url = (storeType === 2 || storeType == 4) ? '/pc/Admin/getTravelTradeDetail' : '/pc/Admin/getStoreExpList';
        break;
      case 'creditDetail':
        url = storeType === 2 ? '/pc/Admin/getTravelDetail' : '/pc/Admin/getStoreActiveDetail';
        break;
      case 'roomTypeTrends':
        url = storeType === 2 ? '/pc/Common/examineRoomState' : '/pc/Common/eAdminDataListsxamineRoomState';
        break;
    }
    let res = await _axios.post(url, {
      num:NUM,
      page:PAGE,
      ...data
    });
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info ||res.data.list ||res.data || [],
          total = res.total_nums || res.num || res.counts || res.count || res.data.count || 0,
          info  = res.data.info || {};
      let name = Router.currentRoute.name,
          query = Router.currentRoute.query;
      if (!lists[0] && total > 0) {
        Router.replace({name,query:{...query,page:PAGE - 1}});
      }
      //else {  Router.replace({name,query:{...query,page:1}}); }
      commit('UPDATEADMINDATALIST', { total, lists, info });
      if (successFun) successFun(res);
      return res;
    }
  },
  /*查看列表项详情*/
  async getItemDetail({ commit, getters,dispatch }, {type,data}) {
    let url = '';
    switch (type) {
      case 'invoice': url = '/pc/Admin/getDrawABillDetails'; break;
      case 'userDetail': url = '/pc/Admin/UserDetail'; break;
      case 'productDetail': url = '/pc/Admin/getProductDetails'; break;
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000' || res.code === '99999') {
      let resInfo = res.data.info || {};
      if (type === 'userDetail') {        //用户详情的账号主体整理
        let titleArr = res.data.user_store_arr.map(v => v.title);
        resInfo.title = titleArr.join(',');
      }
      commit('UPDATEADMINITEMDETAIL',res.data.info || {})
    }
  },
    /*管理获取打款详情*/
  async adminPaymentInfor ({ commit, getters,dispatch }, {data,successFun}) {
    let res = await _axios.post('/pc/Common/PaymentInfo', data);
    if (res.code === '00000') successFun(res.data.info)
  },
  /*修改用户信息*/
  async adminEditUser ({ commit, getters,dispatch }, data) {
    let res = await _axios.post('/pc/Admin/EditUser', data);
    if (res.code === '00000') _alert('修改成功',() => {
      Router.back()
    })
  },
  /*管理员修改提现金额*/
  async editWithdraw({commit, getters}, {data,successFun}) {
    let res = await _axios.post('pc/Admin/editWithdraw', data);
    if (res.code === '00000') _alert('操作成功',successFun)
  },
  /*通知用户已打款*/
  async adminSetWithdraw ({ commit, getters,dispatch }, {data,successFun}) {
    let res = await _axios.post('/pc/Admin/setWithdraw', data)
    if (res.code === '00000') _alert('通知成功',successFun)
  },
  /*通知用户已开票、发票已邮寄*/
  async adminSetInvoice ({ commit, getters,dispatch }, {data,successFun}) {
    let res = await _axios.post('/pc/Admin/setDrawABill', data)
    if (res.code === '00000') _alert('操作成功',successFun)
  },
  /*编辑修改管理员账号信息*/
  async addEditAdmin({ commit, getters,dispatch }, {data,type}) {
    let url = type === 'add' ? '/pc/Admin/AddAdmin' : '/pc/Admin/EditAdmin';
    let res = await _axios.post(url, data)
    if (res.code === '00000') _alert('操作成功',() => { Router.back() })
  },
  /*编辑修改管理员账号信息*/
  async addSavePwd({ commit, getters,dispatch }, {data,type}) {
    let url = '/pc/Admin/SavePwd';
    let res = await _axios.post(url, data)
    if (res.code === '00000') _alert('操作成功',() => { Router.back() })
  },
  /*添加集团单位*/
  async addGroup({ commit, getters,dispatch }, data) {
    let res = await _axios.post('/pc/Admin/AddGroup', {
      trace:1,
      ...data,
    });
    if (res.code === '00000') _alert('操作成功',() => { Router.back() })
  },
  /*更改集团账号状态*/
  async changeStatus({ commit, getters,dispatch }, {item,activeName}) {
    let msg = '禁用当前集团主账号登录（其下子账号不受影响）'
    if (item.status == 0) msg = '启用当前集团主账号登录'
    _confirm(msg, async () => {
      let res = await _axios.post('/pc/Admin/EditUser', {
        uid:item.uid,
        type:item.type,
        truename:item.truename,
        status:item.status ? '0' : '1',
      });
      if (res.code === '00000') dispatch('getAdminDataLists',{type:'group',data:{type: activeName,...this.queryCon}})
    })
  },
  /*获取采购商支付金额总计*/
  async getTotalPay({ commit, getters },data = {}) {
    let res = await _axios.post('/pc/Admin/getPayTotal', {
      store_id:getters.storeInfo.storeId,
      store_type:getters.storeInfo.type,
      sum:'total_fee',
      start_time: data.start,
      end_time: data.end,
      trade_no: data.trade_no
    });
    if (res.code === '00000' || res.code === '99999') return res.info || {};
  },
  /*修改门店审核状态*/
  async verifyStore({ commit, getters,dispatch }, {data,successFun}) {
    let url = '';
    switch (Number(getters.storeInfo.type)) {
      case 2:url =  data.confirm?'/pc/Admin/EditTravelVerify':'/pc/Admin/RegTravelVerify'; break;
      case 3:url =  data.confirm?'/pc/Admin/EditHotelVerify':'/pc/Admin/RegHotelVerify'; break;
      case 4:url =  '/pc/Admin/editGuideDetails'; break;
      case 5:url =  '/pc/Admin/saveHomestayData'; break;
      case 6:url =  '/pc/Admin/saveViewpointData'; break;
      case 8:url =  '/pc/Admin/saveBrandhallData'; break;
    }
    let res = await _axios.post(url,data);
    if (res.code === '00000') _alert('操作成功',() => {
      successFun();
      dispatch('getWaitHandleData');
    })
  },
  /*管理员审核门店促销活动、民宿活动、景区门票等项*/
  async verifyItem({ commit, getters,dispatch }, {data,type,successFun}) {
    let url = '';
    switch (type) {
      case 'hotelActi':url =  '/pc/Admin/adminSaveHotelActive'; break;
      case 'homestayActi':url =  '/pc/Admin/verifyHomestayOnsale'; break;
      case 'ticket':url =  '/pc/Admin/verifyTicket'; break;
    }
    let res = await _axios.post(url,data);
    if (res.code === '00000') _alert('操作成功',() => {
      dispatch('getWaitHandleData');
      if (successFun) successFun();
      else Router.back()
    })
  },
  /*管理员根据用户身份获取全站统计报表*/
  async getUserStateData({ commit, getters,dispatch },data) {
    let res = await _axios.post('/pc/Admin/DataTotal',data);
    console.log(data);
    if (res.code === '00000') {
      //总计数据类型为'0'，直接返回，不触发commit
        commit('UPDATEADMINITEMDETAIL',res.info || {});
        return {
          ...res.info,
          total_pay_price:(res.info.total_pay_price / 100).toFixed(2),
          offline_pay:(res.info.offline_pay / 100).toFixed(2)
        }
    }
  },
  /*获取度假产品、品牌馆套餐历史标签库*/
  async getProductTags({getters}) {
    let data = {
      store_id:getters.storeInfo.storeId,
      store_type:getters.storeInfo.type,
    }
    if (getters.isAdmin) data = {type: 7}
    let res = await _axios.post('/pc/Common/getTagList',data);
    if (res.code === '00000' || res.code === '99999') return res.info || [];
  },
  // 添加品牌馆标签库
  async addTag({getters},{data, successFun}) {
    let res = await _axios.post('/pc/Common/addTag',{
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    });
    if (res.code === '00000' || res.code === '99999') successFun(res)
  },
  /*添加度假产品*/
  async addProduct({ commit, getters,dispatch },data) {
    let res = await _axios.post('/pc/Admin/createProduct',data);
    if (res.code === '00000') _alert('产品添加成功',() => Router.back());
  },
  /*编辑度假产品*/
  async editProduct({ commit, getters,dispatch },{data,successFun}) {
    let res = await _axios.post('/pc/Admin/editProduct',data);
    if (res.code === '00000') {
      if (successFun) successFun();
      else _alert('产品编辑成功',() => Router.back());
    }
  },
  /*批量修改度假产品套餐排序*/
  async sortProduct({ commit, getters,dispatch },data) {
    let url = '/pc/Admin/productSort'
    if (Router.history.current.name == 'editAdvertise') url = '/pc/Admin/SortPromote'
    let res = await _axios.post(url,data);
    if (res.code == '0000') {}
  },
  /*将度假产品设置为主套餐*/
  async setProductDefault({ commit, getters,dispatch },{data,successFun}) {
    let res = await _axios.post('/pc/Admin/productUp',data);
    if (res.code === '00000') _alert('操作成功',successFun);
  },
}
